export const ShareList = {
	name: 'ShareList',
	mounted() {
		this.$on('open-popup', this.openPopup)
	},
	methods: {
		openPopup({ link, popupDims }) {
			let top = (document.documentElement.clientHeight / 2) - (popupDims.h / 2)
			let left = (document.documentElement.clientWidth / 2) - (popupDims.w / 2)

			let parms = "toolbar=0,scrollbars=1,location=0" +
				",width=" + popupDims.w +
				",height=" + popupDims.h +
				",left=" + left +
				",top=" + top;

			window.open(link, 'SharePopup', parms);
		}
	},
	template: `
		<ul class="list list--horizontal">
			<slot></slot>
		</ul>
	`
}
